var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isAssinaturaInserida !== false
    ? _c("div", [
        _c("p", [_vm._v(_vm._s(_vm.informacaoAssinatura))]),
        _c(
          "div",
          { staticClass: "center" },
          [
            _vm._l(_vm.assinatura, function(img, index) {
              return _c(
                "div",
                { key: index },
                [
                  _c("el-image", {
                    staticClass: "h1",
                    staticStyle: { width: "350px", height: "220px" },
                    attrs: { src: img }
                  })
                ],
                1
              )
            }),
            _c("p", [_vm._v(_vm._s(_vm.textoAsssinatura))])
          ],
          2
        )
      ])
    : _c("div", [
        _c("div", { staticClass: "center" }, [
          _c("p", [_vm._v(_vm._s(_vm.termoGaleria))])
        ])
      ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6f45e3e1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f45e3e1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/informacoesCadastro/AssinaturaMobile.vue
// module id = null
// module chunks = 